import React from "react";
import { connect } from "react-redux";
import { Alert, Breadcrumb, Icon, Layout } from "antd";
import { withNamespaces } from "react-i18next";
import get from "lodash/get";
import { Link } from "react-router-dom";

import classes from "./DelegationLogs.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDelegationLogSigningRequest,
  getSitesRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { getDelegationLogSignPermission } from "../../reducers/user/selectors";
import DelegationLogSignForm from "./DelegationLogSignForm";

const routes = require("../../routes.json");

const { Content } = Layout;

class EditDelegationLogSigning extends React.Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(window.location.search);

    this.state = {
      users: [],
      sites: [],
      staffImport: [],
      roles: null,
      delegationLog: null,
      type: params.get("type"),
      errorMessage: this.props.delegationLogSignPermission
        ? null
        : this.props.i18n.t("Permission denied"),
    };
  }

  async componentDidMount() {
    this.getDelegationLogSign();
    this.getSites();
  }

  getSites = async () => {
    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
      }
    }
  };

  getDelegationLogSign = async () => {
    try {
      const { data } = await getDelegationLogSigningRequest({
        id: get(this.props, "match.params.id"),
        type: this.state.type,
      });
      this.setState({ delegationLogEdit: data });
    } catch (e) {
      this.setState({
        errorMessage: "Error",
      });
      if (get(e, 'response.status') === 401) {
        this.props.logout();
      }
    }
  };

  render() {
    const { errorMessage, delegationLogEdit, sites } = this.state;
    const { delegationLogSignPermission } = this.props;

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceDelegationLogs:Delegation Log")}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={routes.admin.delegationLogsSigning}>
                  {this.props.i18n.t(
                    "NamespaceDelegationLogs:Delegation Log Signing List"
                  )}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t("NamespaceDelegationLogs:Delegation Log")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {!errorMessage && (
              <div>
                {delegationLogEdit && delegationLogSignPermission ? (
                  <DelegationLogSignForm
                    id={get(this.props, "match.params.id")}
                    sites={sites}
                    delegationLog={delegationLogEdit}
                    onSubmit={this.onDelegationLogEditSubmit}
                    onCancel={this.onDelegationLogEditHide}
                  />
                ) : (
                  <Icon type="loading" />
                )}
              </div>
            )}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  delegationLogSignPermission: getDelegationLogSignPermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(EditDelegationLogSigning))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/EditDelegationLogSigning.js